var map = {
	"./package_1.jpg": "sPaB",
	"./package_2.jpg": "oH2K",
	"./package_3.jpg": "ogCb",
	"./package_4.jpg": "ZaBA",
	"./package_5.jpg": "ZaYd",
	"./package_6.jpg": "PkuG",
	"./package_7.jpg": "Y9Ye",
	"./package_all.jpg": "yPJY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3rz2";


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/package_.*\.jpg$
// module id = 3rz2
// module chunks = 1